import { render, staticRenderFns } from "./SelfServiceFixed.vue?vue&type=template&id=1b96eb2d&"
import script from "./SelfServiceFixed.vue?vue&type=script&lang=js&"
export * from "./SelfServiceFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports